import {
  SearchkeywordTypeT,
  ViewSearchOptions,
  ActiveFiltersDecodedIO,
} from 'ui-io/task-io/task-search'
import { sortOrderOptions } from 'ui-io/queries/tasks/tasks-query'
import { fold } from 'fp-ts/lib/Either'
import { pipe } from 'fp-ts/lib/function'

const taskSortOptions = {
  priority: 'Priority',
  taskTypes: 'Type',
  scrapeStrategies: 'Strategy',
  projects: 'Project',
  configName: 'Name',
  lastModified: 'Last Modified time',
  created: 'Created time',
} as const

const idleTaskSortOptions = {
  priority: 'Priority',
  configName: 'Title',
  lastModified: 'Last Modified On',
  scope: 'Country Code',
} as const

export type TaskSortItemsT = keyof typeof taskSortOptions
type TaskSortLabelT = typeof taskSortOptions[TaskSortItemsT]
type SortOrderT = typeof sortOrderOptions[keyof typeof sortOrderOptions]

export type IdleTaskSortItemsT = keyof typeof idleTaskSortOptions
type IdleTaskSortLabelT = typeof idleTaskSortOptions[IdleTaskSortItemsT]
type IdleSortOrderT = typeof sortOrderOptions[keyof typeof sortOrderOptions]

export const taskSortMetaData: Record<
  string,
  { label: TaskSortLabelT; value?: SortOrderT }
> = {
  priority: { label: 'Priority' },
  taskTypes: { label: 'Type' },
  scrapeStrategies: { label: 'Strategy' },
  projects: { label: 'Project' },
  configName: { label: 'Name' },
  lastModified: { label: 'Last Modified time' },
  created: { label: 'Created time' },
} as const

export const idleTaskSortMetaData: Record<
  string,
  { label: IdleTaskSortLabelT; value?: IdleSortOrderT }
> = {
  priority: { label: 'Priority' },
  configName: { label: 'Title' },
  lastModified: { label: 'Last Modified On' },
  scope: { label: 'Country Code' },
} as const

export const parseFilterString = (
  viewSearchOptions: ViewSearchOptions,
  activeFilter: string | undefined,
) =>
  pipe(
    activeFilter,
    (filterString) => {
      try {
        return JSON.parse(filterString ?? '{}')
      } catch (error) {
        return {}
      }
    },
    ActiveFiltersDecodedIO.decode,
    fold(
      () => ({}),
      (filters) => {
        if (filters) {
          let validFilters = {}
          /** Validate/process all parsed filter/search items with below checks
           * 1. Filter unique Assignees.
           * 2. Validate list of states by checking if it exists in viewFilterOptions.
           * 3. Except for Assignees and states, other items are part of new V2 _search (i.e key should be of type SearchkeywordTypeT )
           * 4. Except for priority and text all other fields are Array.
           */
          Object.entries(filters).forEach(([key, val]) => {
            const isArrayField = ![
              'priority',
              'text',
              'sorting',
              'fastlane',
              'isAuthorized',
            ].includes(key)

            if (!isArrayField || Array.isArray(val)) {
              if (viewSearchOptions?.[key as SearchkeywordTypeT]) {
                validFilters = { ...validFilters, [key]: val }
              } else if (key === 'sorting') {
                validFilters = { ...validFilters, sorting: val }
              }
            }
          })

          return validFilters ?? undefined
        }
        return
      },
    ),
  )
